import * as React from "react";
import { Link } from "react-router-dom";
import MyChartContainer from "../mychart/MyChartContainer";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";

const Coverage = () => {
    logUI("MBHWeb.UI.Coverage.ComponentDidMount", new Date(), Tools.getURLPath());
    const bswMatch = ".card";
    const events = [{ elements: ".formbuttons .button", eventName: "click", message: "touched" }];


    const heading = <div className="row">
        <div className="col-12 col-md-6">
            <h1 className="page-heading dt-heading-line">Coverage</h1>
        </div>
        <div className="col-12 col-md-6 text-md-right">
            <div className="bswh-mychart-overlay">
                <Link className="btn btn-primary" to={{ pathname: "/insurance" }}>INSURANCE</Link>
            </div>
        </div>
    </div>;
    return <MyChartContainer mode="coverage" title="Coverage" heading={heading}
        events={events}
        bswMatch={bswMatch}
/>;
};

export default Coverage;